<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" md="9" mx-auto>
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="px-0 pt-2 pb-0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-combobox
                v-model="curComm"
                label="Community"
                :items="commList"
                item-text="comm_name"
                item-value="comm_id"
                placeholder="Choose"
                filled
                clearable
                @input="curComm ? loadCompConfig() : ''"
                ></v-combobox>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text v-if="curComm && curComm.comm_id" class="pa-0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-tabs v-model="tab">
                  <v-tab v-for="(tabItem, n) in tabItems" :key="n" :href="`#tab-${n}`">
                    {{ tabItem }}
                  </v-tab>
                </v-tabs>
              </v-flex>
              <v-flex xs12>
                <v-tabs-items v-model="tab">
                  <v-tab-item v-for="(tabItem, n) in tabItems" :key="n" :value="`tab-${n}`">
                    <v-flex xs12 v-if="tabItem === 'General'">
                      <!-- 1. view category-->
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-card>
                            <v-card-title class="pa-2 title primary--text grey lighten-4">
                              <span>Complaints can be addressed to</span>
                              <v-spacer></v-spacer>
                            </v-card-title>
                            <v-card-text class="pt-0">
                              <v-checkbox hide-details v-model="lCompAdr.is_hd_enabled" v-if="isHDPresent" label="Helpdesk Executive" @change="saveCompSet"></v-checkbox>
                              <v-checkbox hide-details v-model="lCompAdr.is_fm_enabled" v-if="isFMPresent" label="FM" @change="saveCompSet"></v-checkbox>
                              <v-checkbox hide-details v-model="lCompAdr.is_mc_enabled" label="Mgmt Committee" @change="saveCompSet"></v-checkbox>
                              <v-checkbox hide-details v-model="lCompAdr.is_res_enabled" label="CC: Residents" @change="saveCompSet"></v-checkbox>
                            </v-card-text>
                          </v-card>
                        </v-flex xs12>
                        <v-flex>
                          <v-card>
                            <v-card-title class="pa-2 title primary--text grey lighten-4">
                              <span>Available Services/Categories</span>
                              <v-spacer></v-spacer>
                              <v-btn icon @click="prepareCreate"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                            </v-card-title>
                            <v-card-text class="pa-0">
                              <v-data-table
                              :headers="catSet"
                              :items="catList"
                              hide-default-footer
                              disable-pagination
                              sort-by="comp_cat"
                              :mobile-breakpoint="0">
                              <template slot="item" slot-scope="props">
                                <tr @click="prepareEdit(props.item)">
                                  <td>{{ props.item.comp_cat }}</td>
                                </tr>
                              </template>
                            </v-data-table>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-else-if="tabItem === 'SLA'">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-form @submit.prevent="saveChangesSla">
                          <v-card>
                            <v-card-title class="pa-2 title primary--text grey lighten-4">
                              <span>SLA</span>
                            </v-card-title>
                            <v-card-text class="pt-2">
                              <v-layout row wrap>
                                <v-flex xs5 class="mt-2">
                                  <span>Critical</span>
                                </v-flex>
                                <v-flex xs3>
                                  <v-text-field class="mt-0 pt-0"
                                  v-model="lCompSla.sla_critical"
                                  hide-details
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs3 class="mt-1">
                                  Hours
                                </v-flex>
                                <v-flex xs5 class="mt-2">
                                  <span>Major</span>
                                </v-flex>
                                <v-flex xs3>
                                  <v-text-field class="mt-0 pt-0"
                                  v-model="lCompSla.sla_major"
                                  hide-details
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs3 class="mt-1">
                                  Hours
                                </v-flex>
                                <v-flex xs5 class="mt-2">
                                  <span>Normal</span>
                                </v-flex>
                                <v-flex xs3>
                                  <v-text-field class="mt-0 pt-0"
                                  v-model="lCompSla.sla_normal"
                                  hide-details
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs3 class="mt-1">
                                  Hours
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions class="pt-0">
                              <v-spacer></v-spacer>
                              <v-btn text type="submit" color="accent">Save</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-form>
                      </v-flex>
                      <v-divider></v-divider>
                      <v-flex xs12>
                        <v-form @submit.prevent="saveChangesSlaEsc">
                          <v-card>
                            <v-card-title class="pa-2 title primary--text grey lighten-4">
                              <span>SLA Escalation</span>
                            </v-card-title>
                            <v-card-title class="title pb-0">
                              Level 1
                            </v-card-title>
                            <v-card-text>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-text-field
                                  v-model="lCompSlaEsc.l1_email_list"
                                  label="Email list (comma seperated)"
                                  hide-details
                                  maxlength="200">
                                </v-text-field>
                              </v-flex>
                              <v-flex xs7 sm5 class="mt-3 pb-0">
                                <v-switch
                                v-model="lCompSlaEsc.l1_sms_enabled"
                                label="Notify via SMS"
                                hide-details
                                ></v-switch>
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm7>
                              <v-text-field
                              v-model="lCompSlaEsc.l1_phone_list"
                              :disabled="!lCompSlaEsc.l1_sms_enabled"
                              label="Phone number list"
                              hint="Eg:- 9741012345,0014266471234"
                              persistent-hint
                              maxlength="200"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                        <v-card-title class="title pb-0 mt-2">
                          Level 2
                        </v-card-title>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-text-field
                              label="Email list (comma seperated)"
                              v-model="lCompSlaEsc.l2_email_list"
                              hide-details
                              maxlength="200">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs7 sm5 class="mt-3 pb-0">
                            <v-switch
                            v-model="lCompSlaEsc.l2_sms_enabled"
                            label="Notify via SMS"
                            hide-details
                            ></v-switch>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm7>
                          <v-text-field
                          :disabled="!lCompSlaEsc.l2_sms_enabled"
                          v-model="lCompSlaEsc.l2_phone_list"
                          label="Phone number list"
                          hint="Eg:- 9741012345,0014266471234"
                          persistent-hint
                          maxlength="200"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions class="pt-0">
                      <v-spacer></v-spacer>
                      <v-btn text type="submit" color="accent">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- SLA Score Config -->
          <v-flex xs12 v-else>
            <v-flex>
              <v-card>
                <v-card-title class="pa-2 title primary--text grey lighten-4">
                  <span>Available SLA Score Config</span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="prepareSLAScoreConfigCreate"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="slaScoreConfigHeader"
                  :items="slaScoreConfigList"
                  hide-default-footer
                  disable-pagination
                  autoRowHeight: false
                  sort-by="comp_cat"
                  :mobile-breakpoint="0">
                  <template slot="item" slot-scope="props">
                    <tr @click="prepareSLAScoreConfigEdit(props.item)">
                      <td style="font-size: 13px; width: 10px ">{{ props.index + 1 }}</td>
                      <td style="font-size: 13px; width: 50px " class="breakline pa-2">{{ props.item.comp_cat }}</td>
                      <td style="font-size: 13px; width: 400px " class="breakline pa-2">{{ props.item.kpi_area }}</td>
                      <td style="font-size: 13px; width: 250px " class="breakline pa-2">{{ props.item.kpi_measure }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            </v-flex>
          </v-flex>
        </v-tab-item>
      </v-tabs-items>
    </v-flex>
  </v-layout>
</v-layout>
</v-card-text>
</v-card>
<!-- 2. create / edit  category-->
<v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="lForm" @submit.prevent="saveChanges(lAction)">
        <v-card flat>
          <v-flex xs12 mx-auto>
            <v-card-title class="title pb-0">
              {{ handy.startWithUpper(lAction) }} category
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 class="mt-2">
                  <v-text-field
                  v-model="lCompCat.comp_cat"
                  label="Category"
                  :rules="[rules.required]"
                  hide-details
                  maxlength="25"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-btn v-if="lAction === 'update'" @click="deleteCat(lCompCat)">delete</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click.stop="cancelChanges">Cancel</v-btn>
              <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>

<v-dialog v-model="showEditSLAScoreConfig" persistent max-width="800px">
  <v-form>
    <v-container v-if="lMAction === 'create' || lMAction === 'update'" class="pa-0" fluid grid-list-md>
      <v-form ref="lSlaScoreConfigList" @submit.prevent="saveSlaScoreConfig(lMAction)">
        <v-card flat class="pa-0">
          <v-card-title class="title py-1">
            {{ handy.startWithUpper(lMAction) }} SLA Score Config
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md class="pt-3 px-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-autocomplete
                  v-model="lSlaScoreConfigList.comp_cat_id"
                  :items="catList"
                  label="SLA Category"
                  item-text="comp_cat"
                  item-value="comp_cat_id"
                  hide-details
                  :rules="[rules.required]"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                  v-model="lSlaScoreConfigList.kpi_area"
                  label="KPI Area"
                  hide-details
                  rows="5"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                  v-model="lSlaScoreConfigList.kpi_measure"
                  label="KPI Measure"
                  hide-details
                  rows="5"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click.stop="cancelEditSLAScoreConfig">Cancel</v-btn>
            <v-btn v-if="lMAction === 'update'" :disabled="beingSaved" @click="deleteSlaScoreConfig(lSlaScoreConfigList)">delete</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-container>
  </v-form>
</v-dialog>


</v-col>
</v-row>
<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  props: ['action'],
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      beingSaved: false,
      tab: 'tab-0',
      sbarMsg: '',
      lCompCat: '',
      commList: [],
      lCompAdr: '',
      lCatList: '',
      lAction: '',
      lCompSla: '',
      lCompSlaEsc: '',
      handy: handy,
      rules: handy.rules,
      noSlaFound: false,
      noSlaEscFound: false,
      tabItems: ['General', 'SLA', 'Score Config'],
      catSet: [
        { text: 'Service', value: 'comp_cat' }
      ],
      catList: [],
      isHDPresent: false,
      isFMPresent: false,
      curComm: null,
      slaScoreConfigList: [],
      slaScoreConfigHeader: [
        { text: 'SNo', value: '' },
        { text: 'Category', value: 'comp_cat' },
        { text: 'KPI Area', value: 'kpi_area' },
        { text: 'KPI Measure', value: 'kpi_measure' }
      ],
      showEditSLAScoreConfig: false,
      lSlaScoreConfigList: [],
      lMAction: '',
    }
  },
  mounted () {
    this.loadCommunity()
    .then(res => {
      if (this.action) {
        var tmp = this.commList.filter(rec => rec.comm_id === Number(this.action))
        this.curComm = tmp[0]
        this.loadCompConfig()
      }
    })
    this.lAction = 'view'
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadCompConfig () {
      this.loadCompSet()
      this.loadCatList()
      this.loadSlaHours()
      this.loadSlaEscLevels()
      this.loadSLAScoreConfig()
    },
    loadCommunity () {
      return new Promise((resolve, reject) => {
        var qry = {
          params: {
            vendor_id: config.VENDOR_ID
          }
        }
        this.axios.get(config.API_URL + '/getCommunityByVendorId/' , qry)
        .then(response => {
          this.commList = response.data
          resolve(true)
        })
        .catch(err => {
          this.msg(err.response.data)
          reject(false)
        })
      })
    },
    loadCompSet () {
      var qry = {
        params: {
          comm_id: this.curComm.comm_id
        }
      }
      // is help desk available for community
      this.axios.get(config.SMARTILITY_API_URL + '/isHelpDeskAvailableForCommunity/', qry)
      .then(response => {
        if (response.data[0].total) {
          this.isHDPresent = true
        } else {
          this.isHDPresent = false
        }
      })
      // is fm available for community
      this.axios.get(config.SMARTILITY_API_URL + '/isFMAvailableForCommunity/', qry)
      .then(response => {
        if (response.data[0].total) {
          this.isFMPresent = true
        } else {
          this.isFMPresent = false
        }
      })
      // complaint settings
      this.axios.get(config.SMARTILITY_API_URL + '/getCompSetByCommId/', qry)
      .then(response => {
        this.lCompAdr = response.data[0]
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    saveCompSet () {
      if (this.lCompAdr.is_hd_enabled || this.lCompAdr.is_fm_enabled || this.lCompAdr.is_mc_enabled || this.lCompAdr.is_res_enabled) {
        this.axios.post(config.SMARTILITY_API_URL + '/category/settings', this.lCompAdr)
        .then(response => {
          // refresh the category address
          this.loadCompSet()
          this.$forceUpdate()
        })
        .catch(err => {
          this.msg(err.response.data)
        })
      } else {
        this.msg('Atleast one option needs to be enabled', 2)
        // refresh the category address
        this.loadCompSet()
      }
    },
    loadCatList () {
      var qry = {
        params: {
          comm_id: this.curComm.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getCompCatListByCommId/', qry)
      .then(response => {
        this.catList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    prepareCreate () {
      this.lCompCat = {
        comm_id: this.curComm.comm_id,
        comp_cat: ''
      }
      this.lAction = 'create'
    },
    prepareEdit (curCat) {
      this.lCompCat = Object.assign({}, curCat) // keep the original object safely before changes
      this.lAction = 'update'
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    saveChanges (action) {
      if (!this.$refs.lForm.validate()) {
        return
      }
      this.axios.post(config.SMARTILITY_API_URL + '/category/' + action, this.lCompCat)
      .then(response => {
        // refresh the Category list
        this.loadCatList()
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    deleteCat (curCat) {
      if (!confirm('Sure, you want to delete the Category "' + curCat.comp_cat + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.SMARTILITY_API_URL + '/category/delete', curCat)
      .then(response => {
        // refresh the list
        this.loadCatList()
        this.lAction = 'view'
        this.beingSaved = false
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    loadSlaHours () {
      var qry = {
        params: {
          comm_id: this.curComm.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getSlaHoursByCommId/', qry)
      .then(response => {
        if (response.data.length === 0) {
          this.noSlaFound = true
          this.lCompSla = {
            sla_critical: null,
            sla_major: null,
            sla_normal: null,
            comm_id: this.curComm.comm_id
          }
        } else {
          this.lCompSla = response.data[0]
          this.noSlaFound = false
        }
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    saveChangesSla () {
      var action = this.noSlaFound ? 'create-sla' : 'update-sla'
      this.axios.post(config.SMARTILITY_API_URL + '/sla/' + action, this.lCompSla)
      .then(response => {
        if (action === 'create-sla') {
          this.noSlaFound = false
        }
        this.msg('Saved successfully', 1)
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadSlaEscLevels () {
      var qry = {
        params: {
          comm_id: this.curComm.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getSlaEscLevelsByCommId/', qry)
      .then(response => {
        if (response.data.length === 0) {
          this.noSlaEscFound = true
          this.lCompSlaEsc = {
            l1_phone_list: '',
            l1_sms_enabled: false,
            l1_email_list: '',
            l2_phone_list: '',
            l2_sms_enabled: false,
            l2_email_list: '',
            comm_id: this.curComm.comm_id
          }
        } else {
          this.lCompSlaEsc = response.data[0]
          this.noSlaEscFound = false
        }
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    saveChangesSlaEsc () {
      var action = this.noSlaEscFound ? 'create-sla-esc' : 'update-sla-esc'
      this.axios.post(config.SMARTILITY_API_URL + '/sla/' + action, this.lCompSlaEsc)
      .then(response => {
        if (action === 'create-sla-esc') {
          this.noSlaEscFound = false
        }
        this.msg('Saved successfully', 1)
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },

    // SLA Score
    loadSLAScoreConfig () {
      var qry = {
        params: {
          comm_id: this.curComm.comm_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getSLAScoreConfigList/', qry)
      .then(response => {
        this.slaScoreConfigList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    prepareSLAScoreConfigCreate () {
      this.lSlaScoreConfigList = {
        comm_id: this.curComm.comm_id,
        vendor_id: config.VENDOR_ID,
        comp_cat_id: '',
        kpi_area: '',
        kpi_measure: ''
      }
      this.showEditSLAScoreConfig = true
      this.lMAction = 'create'
    },
    prepareSLAScoreConfigEdit (curSLAScoreConfig) {
      this.lSlaScoreConfigList = {
        comm_id: this.curComm.comm_id,
        vendor_id: config.VENDOR_ID,
        comp_cat_id: curSLAScoreConfig.comp_cat_id,
        sla_score_config_id: curSLAScoreConfig.sla_score_config_id,
        kpi_area: curSLAScoreConfig.kpi_area,
        kpi_measure: curSLAScoreConfig.kpi_measure
      }
      this.showEditSLAScoreConfig = true
      this.lMAction = 'update'
    },
    cancelEditSLAScoreConfig () {
      this.showEditSLAScoreConfig = false
    },
    deleteSlaScoreConfig (curSLAScoreConfig) {
      if (!confirm('Sure, you want to delete the Category "' + curSLAScoreConfig.comp_cat + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/slascoreconfig/delete', curSLAScoreConfig)
      .then(response => {
        // refresh the list
        this.loadSLAScoreConfig()
        this.lMAction = ''
        this.beingSaved = false
        this.$forceUpdate()
        this.showEditSLAScoreConfig = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
        this.showEditSLAScoreConfig = false
      })
    },
    saveSlaScoreConfig (action) {
      if (!this.$refs.lSlaScoreConfigList.validate()) {
        return
      }
      this.axios.post(config.API_URL + '/slascoreconfig/' + action, this.lSlaScoreConfigList)
      .then(response => {
        // refresh the Category list
        this.loadSLAScoreConfig()
        this.lMAction = ''
        this.beingSaved = false
        this.showEditSLAScoreConfig = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
        this.showEditSLAScoreConfig = false
      })
    }
  }
}
</script>

<style>
.breakline{
  white-space: pre-wrap;
  word-wrap: break-word;
}
 </style>
